import React from 'react';
export function ProblemSection() {
  const problems = ['Mañana caótica sin saber qué mandar en la vianda', 'Domingo perdido pensando recetas que nunca convencen', 'Vianda repetida tres veces porque no hay sistema', 'Tu hijo/hija vuelve con la vianda sin comer', 'Comprás de más, tirás de más, gastás de más', 'Horas perdidas cada semana que nunca recuperás'];
  return <section className="relative bg-cosmic-deep overflow-hidden pt-3 md:pt-5 pb-3 md:pb-4 px-4" data-id="element-284" data-mp="39hcpxqncid4i">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-purple-600/20 rounded-full blur-3xl pointer-events-none" data-id="element-285" data-mp="35gu1m6knvp72"></div>

      <div className="relative max-w-3xl mx-auto text-center" data-id="element-286" data-mp="3jfadsd1am7wl">
        <h2 className="font-display font-bold text-gold text-lg md:text-2xl mb-3" data-id="element-287" data-mp="3ei0k2l6vfa2y">
          ❌ ¿TE SUENA FAMILIAR?
        </h2>

        <div className="space-y-1.5 mb-4 text-left" data-id="element-288" data-mp="1p2at45i22nig">
          {problems.map((p, i) => <div key={i} className="flex items-start gap-2 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg px-2.5 py-1.5" data-id="element-289" data-mp="1k4ismn3cht2n" data-mpi={i}>
              <span className="text-xs md:text-sm shrink-0 mt-0.5" data-id="element-290" data-mp="od9icd1i2edq">❌</span>
              <span className="text-white text-[12px] md:text-sm leading-snug" data-id="element-291" data-mp="sd9xy10c4vmd">
                {p}
              </span>
            </div>)}
        </div>

        <h3 className="font-display font-bold text-white text-[14px] md:text-lg mb-2 leading-snug" data-id="element-292" data-mp="x6mhhwq5qc89">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </h3>

        <p className="italic text-white/80 text-[11px] md:text-sm leading-snug mb-1 max-w-md mx-auto" data-id="element-293" data-mp="1714qnhecezzg">
          Da igual si estás en Buenos Aires, Ciudad de México, Bogotá, Santiago,
          Lima o cualquier ciudad hispanohablante donde los niños van a la
          escuela con vianda.
        </p>
        <p className="italic text-gold font-semibold text-[11px] md:text-sm mb-4 md:mb-5" data-id="element-294" data-mp="3duqh4hqut7nl">
          El problema es el mismo. La solución también.
        </p>

        <div className="max-w-xs mx-auto h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" data-id="element-295" data-mp="ozh44ctj74mo"></div>
      </div>
    </section>;
}